import './sentry'
import { createRoot } from 'react-dom/client'
import App from './App'

import * as Sentry from '@sentry/react'
import { RootOptions } from 'react-dom/client'
import { logError } from 'utils/logger'
import { initHotjar } from 'utils/hotjar'
import { appThunksRegistry } from 'store/with-app-thunks/holder'
import { registerAppThunks } from 'store/with-app-thunks/all-thunks'

const handleError = (
  prefix: string,
  error: Error,
  errorInfo: React.ErrorInfo
) => {
  logError(`${prefix}: ${error.name}`, error, errorInfo.componentStack)
}

const rootOptions: RootOptions = {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) =>
    handleError('Uncaught error', error, errorInfo)
  ),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler((error, errorInfo) =>
    handleError('Caught error', error, errorInfo)
  ),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) =>
    handleError('Recoverable error', error, errorInfo)
  )
}

// Get the root element
const container = document.getElementById('root')

initHotjar()

const bootstrap = async () => {
  registerAppThunks(appThunksRegistry)
  if (container) {
    const root = createRoot(container, rootOptions)
    // Render the app
    root.render(<App />)
  } else {
    // eslint-disable-next-line no-console
    console.error('Root element not found')
  }
}

if (!window.V_EDITOR_READY) {
  // capture users using our product
  initHotjar()
  window.V_EDITOR_READY = true
  bootstrap()
} else {
  logError('Tried to bootstrap app twice')
}
